import React from "react";
import { withRouter } from "react-router-dom";
import Container from "./Container";
import { useQuery } from "react-apollo-hooks";
import { STORE_DETAIL_QUERY } from "../../Queries";

export default withRouter(({ history, match, location }) => {
  const { data, loading } = useQuery(STORE_DETAIL_QUERY, {
    variables: { id: match.params.id }
  });

  if (!loading) {
    // console.log("data");
    // console.log(data);
    // console.log("data");

    return (
      <Container
        history={history}
        match={match}
        location={location}
        store={data}
      />
    );
  } else {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  }
});
